webpackJsonp([234280614081569],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Others = function Others() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "row width-container center-image" },
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/bSB6HvPzOqo",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/UyObNjQhwVs",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/5aIVsCVBgrw",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/afrVrKi4-kw",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/7h0Qc4rhgAA",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/xQ1LZBaMo98",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/3CDjX68uPFI",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/G8n-YLmXqGY",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/eQh2wH03y6I",
	          allowFullScreen: true
	        })
	      )
	    )
	  );
	};
	
	exports.default = Others;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-animation-others-js-1706354fd63ef1af0160.js